import React from "react";

import { useVero1Viewer } from "manager/components/vero1/vero1Viewer";
import { useGetVero1Checklist } from "manager/hooks/api/vero1Queries";
import { Vero1ChecklistStatus } from "shared/interfaces/api/vero1";

import { useVero1ReviewPanel } from "./context";
import { ChevronLeftGlyph } from "./icons";
import { HandleTab, RailChevron, RailDot, RailLabel } from "./styled";

const RAIL_STATUSES = [Vero1ChecklistStatus.Draft];

/**
 * The minimized rail: the docked pane collapsed to a slim strip. It is the
 * single home for an existing review — reachable from any of the deal's pages,
 * before or after the panel has been opened. Clicking it opens the review.
 */
export const Vero1ReviewHandle = () => {
  const { dealId, currentDealId, isOpen, openReview } = useVero1ReviewPanel();
  const railDealId = currentDealId ?? dealId;
  const { canAuthor } = useVero1Viewer();
  // the rail is agent-only UI: leasing users never need this fetch, and on
  // non-VERO1 deals it can only 404
  const { checklist } = useGetVero1Checklist(
    railDealId ?? "",
    Boolean(railDealId) && canAuthor
  );

  if (isOpen || railDealId === null || !canAuthor) {
    return null;
  }

  const status = checklist?.status;
  if (!status || !RAIL_STATUSES.includes(status)) {
    return null;
  }

  const label = "VERO1 review · draft";

  return (
    <HandleTab
      type="button"
      data-testid="vero1-review-handle"
      aria-label="Expand VERO1 review"
      onClick={() => openReview(railDealId)}
    >
      <RailChevron aria-hidden>
        <ChevronLeftGlyph />
      </RailChevron>
      <RailDot aria-hidden />
      <RailLabel>{label}</RailLabel>
    </HandleTab>
  );
};
